import React from 'react';
import Header from './Header';
import Footer from './Footer';
import BackToTop from '../common/BackToTop';
import FelixChatbot from '../common/FelixChatbot';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <BackToTop />
      <FelixChatbot />
    </div>
  );
};

export default Layout;
